import script from "./GlobalTab.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalTab.vue?vue&type=script&setup=true&lang=js"

import "./GlobalTab.vue?vue&type=style&index=0&id=545c8baa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545c8baa"]])

export default __exports__